/**
 * SM-2 preview — DISPLAY ONLY.
 *
 * The server owns scheduling (api/services/SuperMemo.js in teachee-v3); this exists
 * purely so the grade buttons can show "~6 days" before the student commits. Never
 * persist anything computed here — sending a client-computed schedule to the server
 * is exactly the mistake the old mobile flow made.
 *
 * Keep in step with the server implementation if that one ever changes.
 */

const MIN_EFACTOR = 1.3;
const DEFAULT_EFACTOR = 2.5;

export function nextInterval(card, grade) {
  if (!card) {
    return 0;
  }

  const interval = Number(card.interval) || 0;
  const repetition = Number(card.repetition) || 0;
  const efactor = Number(card.efactor) || DEFAULT_EFACTOR;

  if (grade < 3) {
    return 1;
  }
  if (repetition === 0) {
    return 1;
  }
  if (repetition === 1) {
    return 6;
  }
  return Math.round(interval * Math.max(MIN_EFACTOR, efactor));
}

/**
 * "today" / "tomorrow" / "6 days" / "3 weeks" / "5 months"
 */
export function humanizeInterval(days) {
  if (!days || days < 1) {
    return 'today';
  }
  if (days === 1) {
    return 'tomorrow';
  }
  if (days < 21) {
    return `${days} days`;
  }
  if (days < 60) {
    return `${Math.round(days / 7)} weeks`;
  }
  if (days < 365) {
    return `${Math.round(days / 30)} months`;
  }
  const years = Math.round((days / 365) * 10) / 10;
  return years === 1 ? '1 year' : `${years} years`;
}

export default {nextInterval, humanizeInterval};
